// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3DuNv","buttons":"RemoveExpirationActionButtons_buttons__1qCBs"};